/// <amd-module name="Wit/Common/AgileControls/BacklogAnalyticsView" />
import * as React from "react";
import { ObservableValue } from "VSS/Core/Observable";
import { IVssKeyboardShortcutService } from "VSS/Platform/KeyboardShortcuts";
import { IVssLayoutManager, VssComponent, WrappedComponent } from "VSS/Platform/Layout";
import { Observer } from "VSSUI/Observer";
import * as Resources from "Wit/Common/AgileControls/Resources";

/**
 * Additional properties to be published via telemetry
 */
interface ITelemetryProps{
    parentPageName?: string;
    area?: string
}

export interface BacklogAnalyticsViewProps {
    teamId: string;
    teamName: string;
    projectId: string;
    categoryReferenceName: string;
    categoryName: string;
    lastRefresh: ObservableValue<Date>;
    onLoadCompleted: () => void;
}

export class BacklogAnalyticsView extends VssComponent<BacklogAnalyticsViewProps> {
    private shortcutService: IVssKeyboardShortcutService;

    constructor(props: BacklogAnalyticsViewProps, context?: any) {
        super(props, context);

        this.shortcutService = this.context.pageContext.getService<IVssKeyboardShortcutService>("IVssKeyboardShortcutService");
    }

    public componentDidMount() {
        this.registerShortcuts();
    }

    private registerShortcuts = (): void => {
        this.shortcutService.registerShortcut(Resources.KanbanAnalytics, {
            combos: ["z"],
            description: Resources.ToggleFullScreenMode,
            action: () => {
                const layoutManager = this.context.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
                layoutManager.toggleFullScreenMode();
            }
        });
    }

    public componentWillUnmount() {
        this.unregisterShortcuts();
    }

    private unregisterShortcuts = () => {
        this.shortcutService.removeShortcutGroup(Resources.KanbanAnalytics); 
     };

    public render(): JSX.Element {
        return (
            <Observer lastRefresh={this.props.lastRefresh}>
                {(observerProps: { lastRefresh: Date | undefined }) => {
                    return (
                        <WrappedComponent
                            key={"nwp-backlogs-analytics-tab"}
                            dependencies={["ms.vss-web.legacy-content", "ms.vss-web.legacy-vss-ui-content"]}
                            wrappedType="legacy"
                            wrappedProps={{
                                componentType: "backlogsAnalyticsView",
                                modules: ["Agile/Scripts/BacklogsHub/AnalyticsPivot/BacklogsAnalyticsView"],
                                wrappedProps: {
                                    ...this.props,
                                    lastRefresh: observerProps.lastRefresh
                                }
                            }}
                        />
                    );
                }}
            </Observer>
        );
    }
}
